import { Locale } from 'date-fns';
import { da, de, enGB, es, hu, lt, pl, pt, ro, sk, sv, uk } from 'date-fns/locale';

export function getLocale(locale: string): Locale | undefined {
    switch (locale) {
        case 'da': {
            return da;
        }
        case 'sv': {
            return sv;
        }
        case 'sk': {
            return sk;
        }
        case 'ro': {
            return ro;
        }
        case 'lt': {
            return lt;
        }
        case 'de': {
            return de;
        }
        case 'hu': {
            return hu;
        }
        case 'pl': {
            return pl;
        }
        case 'uk': {
            return uk;
        }
        case 'es': {
            return es;
        }
        case 'pt': {
            return pt;
        }
        default: {
            return enGB;
        }
    }
}
